export * from './app-aside.component';



// WEBPACK FOOTER //
// /app/src/app/components/app-aside/index.ts